
export const animation = {
  name: 'animation'
}

export const animationDelay = {
  name: 'animation-delay',
  unit: 'ms'
}

export const animationDirection = {
  name: 'animation-direction'
}

export const animationFillMode = {
  name: 'animation-fill-mode'
}

export const animationIterationCount = {
  name: 'animation-iteration-count'
}

export const animationName = {
  name: 'animation-name'
}

export const animationPlayState = {
  name: 'animation-play-state'
}

export const animationTimingFunction = {
  name: 'animation-timing-function'
}
